import { List, Record } from "immutable";

import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";
import { PolicyConflictsModel } from "./PolicyConflictsModel";

const defaults = {
  bundleIds: [] as string[],
  conflicts: null as null | PolicyConflictsModel,
  createdAt: new Date(0),
  creatorApiTokenId: null as null | string,
  creatorId: "",
  directoryGroupIds: [] as string[],
  id: "",
  integrationResourceRoleIds: [] as string[],
  number: 0,
  onCallIntegrationScheduleIds: [] as string[],
  roles: null as List<IntegrationResourceRoleModel> | null,
  sortOrder: 0,
};

export class PolicyModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown, conflicts: unknown = null) {
    const parsedData = data as typeof defaults;

    return new PolicyModel({
      ...parsedData,
      conflicts: conflicts ? PolicyConflictsModel.fromServerData(conflicts) : null,
      createdAt: parsedData.createdAt ? new Date(parsedData.createdAt) : undefined,
      roles: parsedData.roles
        ? List(parsedData.roles.map((roleData) => IntegrationResourceRoleModel.fromServerData(roleData)))
        : null,
    });
  }
}
